<template>
  <div class="button-container">
    <button @click="handleLogin" :class="[isChange ? 'active' : 'noactive']">
      Sign in
    </button>
  </div>
</template>
<script>
export default {
  name: "ButtonSignIn",
  props: {
    isChange: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async handleLogin() {
      this.$store.dispatch("showLoginDialog");
    }
  }
};
</script>
<style scoped>
.noactive {
  background: #035ae0;
  color: #ffff;
}
.active {
  background: #ffff;
  color: #035ae0;
}
.button-container button {
  border-radius: 35px;
  font-size: 14px;
  font-weight: 600;
  min-width: 91px;
  padding: 10px 20px;
}
</style>
